import {createEntityAdapter, EntityState} from '@ngrx/entity';
import { CustomerOptionsActions, CustomerOptionsActionTypes } from '../../actions/mdqx/customer-options.actions';
import { CustomerOptionsEntity } from '../../../entities/mdqx/customer-options.entity';

export interface CustomerOptionsState extends EntityState<CustomerOptionsEntity> {
    fetched: boolean;
}

export const CUSTOMER_OPTIONS_KEY = 'customerOptions';

const adapter = createEntityAdapter<CustomerOptionsEntity>({
    selectId: customerOptions => customerOptions.Id
});

const initialState = adapter.getInitialState({
    fetched: false
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function customerOptionsReducer(
    state = initialState,
    action: CustomerOptionsActions
): CustomerOptionsState {
    switch (action.type) {
        case CustomerOptionsActionTypes.GetCustomerOptionsResponse: {
            return adapter.setAll(action.Payload, {...state, fetched: true});
        }

        case CustomerOptionsActionTypes.PostCustomerOptionsResponse: {
            return adapter.addOne(action.Payload, state);
        }

        case CustomerOptionsActionTypes.PatchCustomerOptionsResponse: {
            return adapter.setOne(action.Payload, state);
        }

        case CustomerOptionsActionTypes.DeleteCustomerOptionsResponse: {
            return adapter.removeOne(action.Payload, state);
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const {selectAll} = adapter.getSelectors();

export const selectAllCustomerOptions = selectAll;

export const selectCustomerOptionsFetched = (state: CustomerOptionsState) => state.fetched;
